import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { BaseFormControlComponent } from '../../form-control/base-form-control.component';

@Component({
  selector: 'air-textarea-control',
  templateUrl: './textarea-control.component.html',
  imports: [ReactiveFormsModule]
})
export class TextareaControlComponent extends BaseFormControlComponent implements OnInit, OnDestroy {}
